import { useState } from "react"
import { Flex, InputNumber, Modal, Button, Dropdown, Menu } from "antd"
import { useTranslation } from "react-i18next"

export const FilterSettingsModal = ({ onClose, remoteProperties }) => {

    const handleClose = () => onClose()
    const { t } = useTranslation()
    const handleCancelSchedule = () => handleClose()

    function getFilterName(index) {
        return t("page.card-details.settings.group.filtertypes." + index)
    }

    const filterVolumes = [
        {
            key: 0,
            label: "25"
        },
        {
            key: 1,
            label: "50"
        },
        {
            key: 2,
            label: "75"
        },
        {
            key: 3,
            label: "100"
        }, 
        {
            key: 4,
            label: "125"
        },
        {
            key: 5,
            label: "150"
        },
        {
            key: 6,
            label: "175"
        },
        {
            key: 7,
            label: "200"
        },
        {
            key: 8,
            label: "225"
        },
        {
            key: 9,
            label: "250"
        },
        {
            key: 10,
            label: "275"
        },
        {
            key: 11,
            label: "300"
        }
    ]

    function getFilterNames() {
        var Names = new Array(6)
        for (var i = 0; i < 6; ++i)
            Names[i] = { key: i, label: getFilterName(i) }

        return Names
    }

    const filterNames = getFilterNames()


    return (
        <Modal footer={null} width={'635px'} height={'300px'} onCancel={handleCancelSchedule} cancelText="Stäng" open>
            <Menu mode="inline" style={{ marginTop: "40px" }}>
                <Menu.Item onClick={() => { }} key={0}>{t("page.card-details.settings.group.mass")}
                    <Dropdown trigger={['click']} menu={{ items: filterNames, onClick: (e) => { remoteProperties.FilterType = parseInt(e.key) } }}>
                        <Button style={{ float: "right", marginTop: "4px", width: "120px" }}>{getFilterName(remoteProperties.FilterType)}
                        </Button>
                    </Dropdown>
                </Menu.Item>
                <Menu.Item onClick={() => { }} key={1}>{t("page.card-details.settings.group.volume")}
                    <Dropdown trigger={['click']} menu={{ items: filterVolumes, onClick: (e) => { remoteProperties.FilterVolumeIndex = parseInt(e.key) } }}>
                        <Button style={{ float: "right", marginTop: "4px", width: "120px" }}>{filterVolumes[remoteProperties.FilterVolumeIndex].label}
                        </Button>
                    </Dropdown>
                </Menu.Item>
                <Menu.Item onClick={() => { }} key={2}>{t("page.card-details.settings.group.impurity")}
                    <InputNumber size="medium" defaultValue={remoteProperties.WaterImpurityIndex + 1} onChange={(value) => remoteProperties.WaterImpurityIndex = value - 1} style={{ float: "right", marginTop: "4px", width: "120px" }}>
                    </InputNumber>
                </Menu.Item>
                <Flex style={{ justifyContent: "center" }}><Button style={{ width: "200px" }} onClick={onClose} >Spara</Button></Flex>
            </Menu>
        </Modal>
    )
}
export default FilterSettingsModal